"use client";

import { useState } from "react";
import { useAuthStore } from "@/modules/auth/stores/useAuthStore";
import { useAuthModal } from "@/modules/auth/stores/useAuthModal";
import { useFavoritesStore, useIsFavorite } from "@/modules/favorites";

/**
 * Coração do card e da PDP.
 *
 * O valor vem do `useFavoritesStore`, nunca do payload de catálogo: é o que
 * mantém o HTML do servidor idêntico para todos os visitantes e, por
 * consequência, cacheável na borda.
 */
export function useFavoriteProduct(productId: number, onChange?: (favorited: boolean) => void) {
    const isFavorited = useIsFavorite(productId);
    const isGuest = useAuthStore((state) => state.user === null);
    const openModal = useAuthModal((state) => state.openModal);
    const [pending, setPending] = useState(false);

    async function toggle() {
        if (pending) return;
        if (isGuest) {
            openModal("login");
            return;
        }

        setPending(true);
        try {
            const settled = await useFavoritesStore.getState().toggle(productId);
            // `null` = a mutação falhou e o store já reverteu; não avisa o pai.
            if (settled !== null) onChange?.(settled);
        } finally {
            setPending(false);
        }
    }

    return { isFavorited, toggle, pending };
}
